import { render, staticRenderFns } from "./cookie-modal.vue?vue&type=template&id=19fca2c2"
import script from "./cookie-modal.vue?vue&type=script&lang=js"
export * from "./cookie-modal.vue?vue&type=script&lang=js"
import style0 from "./cookie-modal.vue?vue&type=style&index=0&id=19fca2c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports